import { APIGet, APIPost, APIUrl, AdminType, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";

export type TRegisterInventoryDirection = "to_register" | "to_facility";

export type TRegisterInventoryLevel = {
  id: number | null;
  inventory_level_id: number | null;
  register_id: number;
  quantity_available: number;
  variant_id: number;
  facility_quantity_available: number | null;
};

export type TGetRegisterInventory = {
  register_id: number;
  variant_id?: number;
  variant_ids?: Array<number>;
};

export type TPostRegisterInventoryTransfer = {
  register_id: number;
  direction: TRegisterInventoryDirection;
  variants: Array<{ variant_id: number; quantity: number }>;
};

export type TRegisterInventoryTransferResult = {
  variant_id: number;
  register_id: number;
  direction: TRegisterInventoryDirection;
  quantity: number;
  register_quantity_available: number;
  facility_quantity_available: number;
};

export type TGetRegisterInventoryTransfer = {
  register_id: number;
  variant_id?: number;
};

export type TRegisterInventoryTransfer = {
  id: number;
  inventory_level_id: number;
  register_id: number;
  register_inventory_level_id: number;
  admin_user_id: number | null;
  direction: TRegisterInventoryDirection;
  quantity: number;
  previous_quantity: number | null;
  new_quantity: number | null;
  created_at: string;
  updated_at?: string;
};

export async function GetRegisterInventory(
  params: TGetRegisterInventory,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<Array<TRegisterInventoryLevel>>> {
  return await APIGet<Array<TRegisterInventoryLevel>>(
    APIUrl(AdminType.FacilityAdmin, "/product/inventory/register"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function GetRegisterInventoryTransfer(
  params: TGetRegisterInventoryTransfer,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<Array<TRegisterInventoryTransfer>>> {
  return await APIGet<Array<TRegisterInventoryTransfer>>(
    APIUrl(AdminType.FacilityAdmin, "/product/inventory/register/transfer"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PostRegisterInventoryTransfer(
  params: TPostRegisterInventoryTransfer,
  useGlobalLoader: boolean,
): Promise<IAPIResponse<Array<TRegisterInventoryTransferResult>>> {
  return await APIPost<Array<TRegisterInventoryTransferResult>>(
    APIUrl(AdminType.FacilityAdmin, "/product/inventory/register/transfer"),
    params,
    useGlobalLoader,
  );
}
